/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Prereq_1Inputs */

const en_directory_mcp_prereq_1 = /** @type {(inputs: Directory_Mcp_Prereq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your agent completes the skill.md flow once: register the deployed product, the owner approves.`)
};

const zh_directory_mcp_prereq_1 = /** @type {(inputs: Directory_Mcp_Prereq_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 agent 先完成一次 skill.md 流程：注册已部署的产品，由所有者批准。`)
};

/**
* | output |
* | --- |
* | "Your agent completes the skill.md flow once: register the deployed product, the owner approves." |
*
* @param {Directory_Mcp_Prereq_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_prereq_1 = /** @type {((inputs?: Directory_Mcp_Prereq_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Prereq_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_prereq_1(inputs)
	return zh_directory_mcp_prereq_1(inputs)
});
export { directory_mcp_prereq_1 as "directory.mcp.prereq_1" }